export default "__VITE_ASSET__DPZs81_0__"